// openEHR BASE model — barrel for base.base_types
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

// Evaluation-order guard: these BMM packages import each other, so they must be
// entered in this order before anything else pulls one of them in.
import "../foundation_types/primitive_types.ts";
import "../foundation_types/foundation_types.ts";
import "../foundation_types/structure.ts";

export * from "./definitions.ts";
export * from "./identification.ts";
export * from "./builtins.ts";
